module.exports = __webpack_public_path__ + "static/img/login-bg.7d0b078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login-bg.png
// module id = vcJX
// module chunks = 1